import AppSettings from './App.config.json'
import { AppConfig } from './interfaces/Types'
import { toBoolean } from './utils/Utils'

const appConfig: AppConfig = AppSettings as AppConfig
const environment = process.env.NODE_ENV

export const moduleClass = appConfig.moduleType
export const moduleID = appConfig.moduleID
export const moduleName = appConfig.name

export const debugUsername = appConfig.debugUserName
export const debugUserID = appConfig.debugUserID
export const debugCompanyID = appConfig.debugCompanyID

export const isDebug: boolean = (environment === 'development' || environment === 'test') ? true : toBoolean(appConfig.isDebug)
export const build: string = appConfig.build
export const commitID: string = appConfig.commitID
export const environmentName: string = (environment === 'development') ? environment : appConfig.environmentName

export const rxdURL: string = appConfig.RXD[environment].rootURL
export const xAPIURL: string = appConfig.XAPI[environment].learningEngineURL

const getLMSRequirement = (env: typeof environment): boolean => {
    const setting: string = appConfig.RXD[env].LMSRequired.toLowerCase()
    return toBoolean(setting)
}

export const lmsRequired: boolean = getLMSRequirement(environment)

const rxdScripts = {
    jquery: rxdURL + 'jquery.js',
    configuration: rxdURL + 'configuration.js',
    lzstring: rxdURL + 'lz-string.min.js',
    minify: rxdURL + 'minify.json.js',
    utilityFuncs: rxdURL + 'UtilityFunctions.js',
    scormDriver: rxdURL + 'SCORMDriverXD_CS.js'
}

export const loadScripts = () => {
    isDebug && console.log('Loading scripts...')
    return getLibrary(rxdScripts.configuration)
        .then(() => Promise.all([
            getLibrary(rxdScripts.jquery),
            getLibrary(rxdScripts.lzstring),
            getLibrary(rxdScripts.minify),
        ]))
        .then(() => getLibrary(rxdScripts.utilityFuncs))
        .then(() => getLibrary(rxdScripts.scormDriver))
        .then(() => {
            window.SCORMDriver.GetStudentID() // Testing that scripts are loaded properly.
            isDebug && console.log(`Scripts loaded successfully from ${rxdURL}`)
        })
        .catch(error => {
            console.error(error)
            throw new Error(`Unable to load RXD script files from ${rxdURL}. Error: ${error}`)
        })
}

const getLibrary = (url: string) => {
    const headTag = document.getElementsByTagName('head')[0]
    //console.log(`Loading script ${url}`)
    return new Promise((resolve, reject) => {
        const scriptHTML = document.createElement('script')

        scriptHTML.type = 'text/javascript'
        scriptHTML.charset = 'utf-8'
        scriptHTML.async = true
        scriptHTML.src = url

        scriptHTML.onload = function() {
            resolve(url)
        }
        scriptHTML.onerror = function() {
            reject('error')
        }

        headTag.appendChild(scriptHTML)
    })
}